import React from "react";
import Img from "gatsby-image";

import AnimatedSlogan from "components/AnimatedSlogan";

const Header = ({ headerData, location, locationData, navHeight }) => {
  let imageSize;
  if (location.pathname !== "/") imageSize = "h-51vh";
  else imageSize = "h-screen";
  let top = 0;
  if (typeof window !== `undefined`) {
    top = (1 - (window.innerHeight - navHeight) / window.innerHeight / 2) * 100;
  }

  const headerImg = locationData ? headerData[locationData.headerImageName] : null;
  return (
    <React.Fragment>
      {locationData && <Img fluid={headerImg.fluid} className={imageSize} />}
      {location.pathname === "/" ? (
        <div
          className="absolute pin-middle text-white max-w-xl z-10"
          style={{ top: top + "%" }}
        >
          <h1 className="text-4xl md:text-5xl uppercase mb-4 font-serif">
            {headerData.websiteTitle}
          </h1>
          <p className="text-2xl mb-16">{headerData.companyType}</p>
          <AnimatedSlogan slogans={headerData.slogan} />
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Header;
